
import { oz } from '@weft/utils';

export const NET_SUITE_BILLING_STATUSES = Object.freeze({
  Open: 'Open',
  PendingApproval: 'Pending Approval',
  PaidInFull: 'Paid in Full',
  Rejected: 'Rejected',
  Voided: 'Voided',
});

export const NetSuiteBillingStatusSchema = oz.nativeEnum(NET_SUITE_BILLING_STATUSES).openapi('NetSuiteBillingStatus');
export type NetSuiteBillingStatus = oz.infer<typeof NetSuiteBillingStatusSchema>;